module.exports = __webpack_public_path__ + "img/cashier-service-01.38148deb.png";